/**
 * Cookie writer. The app persists everything else in localStorage /
 * sessionStorage / Firestore — a cookie is only used where a value has to
 * survive a hop to another subdomain, which localStorage (origin-scoped)
 * cannot do. Today that is the beta redirect (`plugins/beta-redirect.client.ts`).
 *
 * Same guards as `ownerDashSession.ts`: environment check, try/catch.
 */

export const setCookie = (
  name: string,
  value: string,
  days: number,
  domain?: string,
): void => {
  try {
    if (typeof document === 'undefined') return
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
    const parts = [
      `${name}=${encodeURIComponent(value)}`,
      `expires=${expires}`,
      'path=/',
    ]
    if (domain) parts.push(`domain=${domain}`)
    document.cookie = parts.join('; ')
  } catch {
    /* ignore disabled cookies */
  }
}
